import { uniqBy } from 'lodash';

export const arrUniqEl = <T>(arr: T[], fieldName: keyof T): T[] => {
  return uniqBy(arr, fieldName);
};
